import React from 'react';
import Modal from '../../Modal';
import { inject, observer } from 'mobx-react';
import { ratingEquation as api } from '../../../actions/api'
import { observable, toJS } from 'mobx';
import DataTable from '../../DataTable';
import { getDisplayDate } from '../../../libs/date';

@inject('userStore', 'ratingEquationStore')
@observer
class REAuditHistory extends React.Component {
  static contextTypes = {
    notify: React.PropTypes.object.isRequired,
  };


  @observable items = [];
  @observable isLoading = false;
  columns = [
    { key: 'user.name', label: 'Modified By' },
    { key: 'timestamp', label: 'Timestamp' },
    { key: 'series_type.label', label: 'Series Type' },
    { key: 'offset', label: 'Offset' },
    { key: 'a', label: 'a' },
    { key: 'b', label: 'b' },
    { key: 'c', label: 'c' },
    { key: 'stage_from', label: 'Stage From' },
    { key: 'stage_to', label: 'Stage To' },
  ];

  componentWillMount() {
    const { params: { id, eq_id }, userStore } = this.props;
    if (!userStore.isLoading && !userStore.items.length) userStore.fetchItems();
    api.audit.fetchAll(id, eq_id).then(res => {
      this.items = res;
      this.isLoading = false;
    }).catch(err => {
      console.log(err);
      this.isLoading = false;
      this.context.notify.error({ message: err.toString() });
    });
  }

  render() {
    const { params, onClose, userStore, ratingEquationStore } = this.props;
    const slug = `/hydrology/rt_equations/${params.id}/equation/${params.eq_id}`
    const items = this.items.map(item => {
      return Object.assign({}, toJS(item), {
        timestamp: getDisplayDate(item.timestamp),
        user: userStore.findById(item.user_id),
        series_type: ratingEquationStore.seriesTypeOptions.find(type => type.value === +item.type),
      });
    })
    return (
      <Modal title='Audit History' slug={slug} closeModal={onClose} isLoadin={userStore.isLoading || this.isLoading}>
        <div>
          <DataTable data={items} columns={this.columns} />
          <br />
        </div>
      </Modal>
    );
  }
}

export default REAuditHistory;


// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/REAuditHistory.js